/**
 * The panel's two gates, as the client sees them.
 *
 * The admin BFF computes `me.access = { platform, crm }` from the token and
 * enforces it on every request; the client only uses it to decide what to
 * OFFER — which nav items exist, which route renders a screen and which the
 * 403 page, and where `/` lands. The server stays the authority.
 *
 * Kept pure so the whole matrix is testable without rendering.
 */

/** The Keycloak role each gate names, for the 403 page's detail line. Identifiers — never translated. */
export const GATE_ROLES = {
  platform: 'platform_admin',
  crm: 'crm_admin · marketing',
};

/**
 * `{ platform, crm }`, or null while `me` is still loading.
 *
 * When `me` failed, or came from a BFF that predates the access model, the
 * answer is the panel as it was before the CRM half existed: platform only. A
 * caller who is not platform staff then meets the BFF's own FORBIDDEN, which
 * is the same outcome they had before this change.
 */
export function accessOf({ me, status } = {}) {
  if (status === 'loading') return null;
  if (me?.access) return { platform: !!me.access.platform, crm: !!me.access.crm };
  return { platform: true, crm: false };
}

/** Does `access` satisfy `requires` ('platform' | 'crm' | undefined)? */
export function allows(access, requires) {
  if (!requires) return true;
  return !!access?.[requires];
}

/** Where `/` should land for this caller, or null when nothing is open to them. */
export function homePath(access) {
  if (!access) return null;
  if (access.platform) return '/dashboard';
  if (access.crm) return '/demo-requests';
  return null;
}
